export default __webpack_public_path__ + "static/media/overview-active.1b25c62e.svg";